import { useEffect, useState } from 'react'
import useGlobalStore from '@/store/useGlobalStore'

export const useCheckDifferentMarket = () => {
  const {
    app: { alpha2 },
    user: { customer },
  } = useGlobalStore()
  const [isDifferentMarket, setIsDifferentMarket] = useState(false)
  const [userCountry, setUserCountry] = useState<string | null>(null)

  useEffect(() => {
    const country = customer?.mainAddress?.country || null
    setUserCountry(country)
    if (!country) {
      setIsDifferentMarket(true)
      return
    }

    const differentMarket = country !== alpha2
    setIsDifferentMarket(differentMarket)
  }, [customer?.mainAddress?.country, alpha2])

  return {
    isDifferentMarket,
    userCountry,
  }
}
